(function (angular, app) {
   "use strict";
   
   // LoginController
   angular.module(app.modules.ui.name)
      .controller(app.modules.ui.controllers.login, LoginController);
   
   // Injector
   LoginController.$inject = ["$scope", "$timeout",  "ngDialog"
   , app.modules.ui.services.ui
   , app.modules.common.services.functions
   , app.modules.common.constants.appmessaging
   ];
   
   //
   function LoginController($scope, $timeout, ngDialog, ggUISvc
       , ggFunctions
       , ggMessaging
       ) {
         
      var ctrl = this;
      
      ctrl.branding = app.Branding;

      $scope.Temp = {
         window: ggFunctions.fetchWindowSize()
      }

      ctrl.form = {
         username : app.Member.Auth.userName
         , password : app.Member.Auth.password
      }
      
      ctrl.alert = "";
      ctrl.isProcessing = false;

      ctrl.register = function(){
         ngDialog.closeAll();
         ggFunctions.goToPage(app.modules.view.routes.register.path);
      }
      ctrl.password = function(){
         ggUISvc.modal.open.password();
      }
      
      ctrl.login = function(){

         // Set variables to Member object
         app.Member.Auth.userName = ctrl.form.username;
         app.Member.Auth.password = ctrl.form.password;
         
         ctrl.isProcessing = true;
         app.Member.Authenticate.Login().then(function (data) {
            if (data && data.status == "200") {
               

               return app.Member.Authenticate.ValidateToken().then(function (data) {
                  if (app.Member.Auth.isAuthenticated) {
                     ctrl.alert = ggMessaging.loginrequest.success;
                     ngDialog.closeAll();
                     // We can't load the page until all dom elements are done processing
                     $timeout(function () {
                         ggFunctions.goToPage(app.modules.view.routes.intro.path);
                     }, 200);
                  } else {
                     ctrl.alert = ggMessaging.loginrequest.fail;
                  }
               });


            } else {
               ctrl.alert = data.statusText;
            }
         }).finally(function () { ctrl.isProcessing = false;});
      }

      ctrl.cancel = function () {
         ggUISvc.modal.open.close();
      }
      

      

      
   }
}(angular, app));
